import base from "../middlewares/interceptors";
import { myPoliciesUrl } from "./constants/permissions";

export interface MyPoliciesResponse {
  user_id: number;
  roles: { id: number; name: string }[];
  is_admin: boolean;
  allowed_policies: { entity: string; action: string }[];
}

export const fetchMyPolicies = async (): Promise<MyPoliciesResponse> => {
  const res = await base.get(myPoliciesUrl);
  return res.data as MyPoliciesResponse;
};

